var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComponent4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 592,
    height: 696,
    viewBox: "0 0 592 696",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M507.536 358.971C507.536 358.971 500.11 365.416 485.267 375.246C485.236 375.269 494.442 401.23 494.802 403.752C493.442 403.438 492.05 401.658 492.05 401.658C492.05 401.658 479.558 379.576 479.343 379.254C466.515 386.821 454.06 393.63 439.275 401.469C438.845 401.019 462.771 382.29 475.297 373.216C474.584 372.158 459.074 352.796 457.349 350.276C456.804 348.733 457.355 347.988 457.355 347.988C457.355 347.988 480.66 368.614 481.377 369.645C497.02 360.183 505.034 356.019 505.034 356.019C515.503 351.188 507.547 358.987 507.547 358.987",
    fill: "#799DD2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M390.838 420.977C258.159 474.563 47.1758 438.115 -70.126 262.845L-52.8577 257.439C12.409 380.099 234.703 499.967 432.373 402.075C428.221 406.908 396.579 418.715 390.838 420.977Z",
    fill: "#799DD2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent4);
export default __webpack_public_path__ + "static/media/Component 4.aba5d9b7da83d76217186cd3f30a895e.svg";
export { ForwardRef as ReactComponent };